export const theme = {
    color: {
        white: '#ffffff',
        black: '#000000',
        primary: '#15728d',
    },
};
